

<script>
export default {
    model: {
        prop: 'isEnabled',
        event: 'toggle',
    },
    props: {
        isEnabled: Boolean,
        color: {
            type: String,
            required: false,
            default: '#808080',
        },
    },
    methods: {
        toggle() {
            this.$emit('toggle', !this.isEnabled);
        },
    },
};
</script>

<template lang="pug" src='./template/SwitchButton.pug' />
<style lang="stylus" src='./styles/SwitchButton.styl' scoped />
